import { useEffect, useState } from "react";

/**
 * Returns `true` while the element in `ref` is visible on screen.
 * Used to only play videos that can actually be seen.
 *
 * @param {React.RefObject} ref      The element to watch.
 * @param {string} [rootMargin]      Grow/shrink the viewport, CSS-margin style.
 */
export default function useInView(ref, rootMargin = "0px") {
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el || !("IntersectionObserver" in window)) return;

    const observer = new IntersectionObserver(
      ([entry]) => setInView(entry.isIntersecting),
      { rootMargin }
    );
    observer.observe(el);
    return () => observer.disconnect();
  }, [ref, rootMargin]);

  return inView;
}
